/** 
 Copyright Highway9 Networks Inc. 
 */ 
import { ReduxMiddleware } from "..";
import { socketRefreshHandler } from "./socketrefreshHander";
import { authenticationService } from "~/services";
import { utilityActions } from "../context/utilitySlice";
import {
  connectEventsSocket,
  disconnectEventsSocket,
  initEventsSocketClient,
  sendEventsSocket,
} from "~/sw/eventWebsocket/eventsSocketClient";

const env = window.location.protocol === 'https:' ? `wss://` :  `ws://`
const url = `${env}${window.location.host}/websocket`

let clientInitialized = false;

function ensureClient(api: Parameters<ReduxMiddleware>[0]) {
  if (clientInitialized) return;
  clientInitialized = true;

  initEventsSocketClient({
    onStatus: (status) => {
      if (status === "connected") {
        api.dispatch(utilityActions.setWebSocketStatus("connected"));
      } else {
        api.dispatch(utilityActions.setWebSocketStatus("reconnecting"));
      }
    },
    onFlush: (items) => {
      // One worker flush may contain radios + edges + devices; route each to evt bus.
      for (const { objectType, patches } of items) {
        socketRefreshHandler(objectType, patches);
      }
    },
  });
}

const webSocketMiddleWare : ReduxMiddleware = (api) => (next) => (action) => {
  switch (action.type) {
    case "socket/connect":
      ensureClient(api);
      {
        const token = authenticationService.currentUserValue!.token;
        void connectEventsSocket(url, token).catch((err) => {
          console.error("Events socket worker connect failed:", err);
        });
      }
      break;
    case "socket/disconnect":
      void disconnectEventsSocket();
      break;
    case "socket/send":
      void sendEventsSocket(action.payload);
      break;

    default:
      break;
  }
  return next(action);
}
export default webSocketMiddleWare;

export function connectSocket() {
  return { type: "socket/connect" } as const;
}
